// extracted by mini-css-extract-plugin
export default {"help-button":"RedemptionAmountMessage_help-button__+q3tR","redemption-message":"RedemptionAmountMessage_redemption-message__akP0q"};